module.exports = __webpack_public_path__ + "static/media/delete.097d2e48.svg";